import cx from "classnames";

import BackButton from "../../../../../src/assets/images/back-button.svg";

import styles from "./styles.module.scss";

const HeaderModule = ({
  title = "Learning Difficulties",
  className,
  onBackClick,
  minutes,
  seconds,
  isDanger,
}) => {
  return (
    <div className={styles["header-wrapper"]}>
      <img
        className={styles["back-button"]}
        src={BackButton}
        alt="back"
        onClick={onBackClick}
      />

      <div className={cx(styles.header, className)}>{title}</div>
      
      {minutes && seconds && (
        <div className={cx(styles.timer, isDanger && styles["timer-danger"])}>
          {minutes}:{seconds}
        </div>
      )}
    </div>
  );
};
export default HeaderModule;
